// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"149":"f68edd44","568":"dbe60178","649":"7f508d74","722":"84cbb6bc"}[chunkId] + ".chunk.js";
};